import React from "react";
import TableDelivery from "../../componentes/Tabla/TableDelivery";

export default function DeliveryList() {
  return (
    <TableDelivery />
  )
}